export default {
	selectedPosters: [],
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/store/print-posters/state.js